<script setup lang="ts"></script>

<template>
  <div class="top-r8 right-r8 absolute size-12">
    <div
      class="bg-client-orange size-full rounded-full transition-transform duration-300 group-active/exercise-card:scale-100 lg:group-hover/exercise-card:scale-120"
    ></div>
    <SVGArrowSharp class="absolute inset-1/2 size-1/2 -translate-1/2" />
  </div>
</template>
